import type { ObservabilityEnvironment } from "./contracts";

const LOCAL_ENVIRONMENT_ALIASES = new Set([
  "",
  "dev",
  "development",
  "local",
  "localhost",
  "test",
  "testing",
]);

const STAGING_ENVIRONMENT_ALIASES = new Set([
  "preview",
  "preprod",
  "stage",
  "staging",
]);

const PRODUCTION_ENVIRONMENT_ALIASES = new Set(["prod", "production"]);

export function normalizeObservabilityEnvironment(
  value?: string | null,
): ObservabilityEnvironment {
  const normalizedValue = value?.trim().toLowerCase() ?? "";

  if (PRODUCTION_ENVIRONMENT_ALIASES.has(normalizedValue)) {
    return "production";
  }

  if (STAGING_ENVIRONMENT_ALIASES.has(normalizedValue)) {
    return "staging";
  }

  if (LOCAL_ENVIRONMENT_ALIASES.has(normalizedValue)) {
    return "local";
  }

  return "local";
}
